import restService from "../restService";

/**
 * Retrieves all members of a campaign.
 * @async
 * @function getMembers
 * @returns {Promise<Array>} An array of all members of the campaign.
 */
export const getMembers = async (campaign, user) => {
  try {
    const {
      data: { results },
    } = await restService.Settings.getAllMembers(campaign.id, user.accessToken);

    let admins = results?.admins;
    let agents = results?.agents;
    let reporters = results?.reporters;
    let customerSupports = results?.customerSupport || [];

    let allMembers = admins
      .map((admin) => {
        admin.role = "admin";
        admin.username = admin.name;
        admin.confirm = false;

        return admin;
      })
      .concat(
        agents.map((agent) => {
          agent.role = "agent";
          agent.username = agent.name;
          agent.confirm = false;

          return agent;
        })
      )
      .concat(
        reporters.map((reporter) => {
          reporter.role = "reporter";
          reporter.username = reporter.name;
          reporter.confirm = false;

          return reporter;
        })
      )
      .concat(
        customerSupports?.map((customerSupport) => {
          customerSupport.role = "customer-support";
          customerSupport.username = customerSupport.name;
          customerSupport.confirm = false;

          return customerSupport;
        })
      );

    return allMembers;
  } catch (error) {
    console.log(error);
    return [];
  }
};
